import { Route, Switch } from 'wouter';
import Layout from './components/Layout';
import LoginPage from './pages/Login';
import HomePage from './pages/Home';
import AnalyticsPage from './pages/Analytics';
import TimeAnalyticsPage from './pages/TimeAnalytics';
import QueuePage from './pages/Queue';
import SettlementsPage from './pages/Settlements';
import HistoryPage from './pages/History';
import SettingsPage from './pages/Settings';
import StaffPage from './pages/Staff';

function WithLayout({ children }: { children: React.ReactNode }) {
  return <Layout>{children}</Layout>;
}

function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 p-8" dir="rtl">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-300">404</h1>
        <p className="mt-4 text-xl text-gray-600">الصفحة غير موجودة</p>
        <a
          href="/"
          className="mt-8 inline-block rounded-xl bg-primary-600 px-6 py-3 font-semibold text-white transition hover:bg-primary-700"
        >
          العودة للوحة التحكم
        </a>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Switch>
      <Route path="/login" component={LoginPage} />

      <Route path="/">
        <WithLayout><HomePage /></WithLayout>
      </Route>
      <Route path="/analytics">
        <WithLayout><AnalyticsPage /></WithLayout>
      </Route>
      <Route path="/time-analytics">
        <WithLayout><TimeAnalyticsPage /></WithLayout>
      </Route>
      <Route path="/queue">
        <WithLayout><QueuePage /></WithLayout>
      </Route>
      <Route path="/settlements">
        <WithLayout><SettlementsPage /></WithLayout>
      </Route>
      <Route path="/history">
        <WithLayout><HistoryPage /></WithLayout>
      </Route>
      <Route path="/settings">
        <WithLayout><SettingsPage /></WithLayout>
      </Route>
      <Route path="/staff">
        <WithLayout><StaffPage /></WithLayout>
      </Route>

      <Route component={NotFound} />
    </Switch>
  );
}
